import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Layout from '../components/layout'
import SEO from '../components/seo'
import ProductSearch from '../components/product-search'

import { porductTypes } from '../utils/site-data'
import useScreen from '../hooks/use-screen'

const SEARCH_RWD_PROPS = {
  xl: {
    perPage: 20,
    perRow: 4,
    align: 'left',
  },
  md: {
    perPage: 18,
    perRow: 3,
    style: {
      marginBottom: '80px',
    },
  },
  sm: {
    perPage: 18,
    perRow: 3,
    style: {
      marginBottom: '72px',
    },
  },
  xs: {
    perPage: 16,
    perRow: 2,
  },
}

const ProductTypePage = ({pageContext}) => {
  const {
    type,
    lang,
    sitePrefix,
    allProducts,
    siteTitle,
  } = pageContext

  const screen = useScreen()

  const { t } =  useTranslation()

  const [searchPros, setSearchProps] = useState(
    SEARCH_RWD_PROPS[screen] || SEARCH_RWD_PROPS['xl']
  )
  const [aside, setAside] = useState({
    sitePrefix,
    cat: 'product',
    menu: [
      {
        label: lang === 'zh' ? '全部' : 'All',
        slug: `${type.slug}/`,
      },
      ...type.categories.map(cat => ({
        label: cat.label,
        slug: `${type.slug}/?cat=${cat.key}`,
      })),
    ],
    pdfLink: type.pdfLink,    
  })

  useEffect(() => {
    setSearchProps(SEARCH_RWD_PROPS[screen] || SEARCH_RWD_PROPS['xl'])
  }, [screen])

  return (
    <Layout aside={aside} {...pageContext}>
      <SEO title={siteTitle} lang={lang} />
      <ProductSearch
        sitePrefix={sitePrefix}
        showTitle={false}
        showFilter={false}
        screen={screen}
        allProducts={allProducts}
        selectedType={{
          id: type.id,
          label: type.title,
          slug: type.slug,
        }}
        {...searchPros}
      />
    </Layout>
  )
}

export default ProductTypePage
